// @ts-nocheck
import React from 'react';
import { LifeBuoy } from 'lucide-react';
import { useAppContext } from '../context/AppContext';
import './OnboardingTrigger.css';

/**
 * Déclencheur manuel du tutoriel (react-joyride). Ne modifie pas l’état tant qu’on ne clique pas.
 */
export default function OnboardingTrigger() {
  const { setOnboardingTourRun } = useAppContext();

  return (
    <button
      type="button"
      className="onboarding-trigger"
      onClick={() => setOnboardingTourRun(true)}
      title="Lancer le tutoriel"
      aria-label="Lancer le tutoriel interactif"
    >
      <LifeBuoy size={20} strokeWidth={2} aria-hidden />
      <span className="onboarding-trigger__label">Tutoriel</span>
    </button>
  );
}
